// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__jtLUk","navbar":"Layout_navbar__2jzxU","links":"Layout_links__jkOtx","footer":"Layout_footer__3QoUo","alert":"Layout_alert__MY3P4"};